import React from "react";
import { motion } from "framer-motion";
import {
  Brain,
  Smile,
  Heart,
  Sun,
  Users,
  Activity,
  Cloud,
  Zap,
} from "lucide-react"; 
import Welcome from "../assets/Welcome.png";

const container = {
  hidden: { opacity: 0, y: 40 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, staggerChildren: 0.18 },
  },
};

const item = {
  hidden: { opacity: 0, y: 25 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7 } },
};

const OfferSection = () => {
  const offers = [
    { icon: <Smile className="w-10 h-10 text-orange-500" />, title: "RELAXATION", desc: "It's crucial to understand how to prevent others from playing such games with you." },
    { icon: <Brain className="w-10 h-10 text-orange-500" />, title: "MIND GAMES", desc: "It's crucial to understand how to prevent others from playing such games with you." },
    { icon: <Cloud className="w-10 h-10 text-orange-500" />, title: "DEPRESSION", desc: "If your depression keeps you from living your life, seek help sooner." },
    { icon: <Sun className="w-10 h-10 text-orange-500" />, title: "MEDITATION", desc: "Learn to deal with difficult emotions using healthy mental strategies." },
    { icon: <Activity className="w-10 h-10 text-orange-500" />, title: "CONFLICTING", desc: "Focus your attention on calmness and increase your inner awareness." },
    { icon: <Heart className="w-10 h-10 text-orange-500" />, title: "FEELINGS", desc: "Achieve emotional balance and manage feelings more effectively." },
    { icon: <Zap className="w-10 h-10 text-orange-500" />, title: "MENTAL HEALTH", desc: "Improve focus, relieve stress, and boost mental well-being." },
    { icon: <Users className="w-10 h-10 text-orange-500" />, title: "RELATIONSHIP", desc: "Strengthen your relationships through guided therapy." },
  ];

  return (
    <motion.section
      className="bg-white py-20"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-80px" }}
      variants={container}
    >
      <div className="max-w-7xl mx-auto px-6 text-center">

        {/* Title */}
        <motion.h2
          variants={item}
          className="text-3xl md:text-4xl font-bold text-gray-900 mb-12"
        >
          What We Can Offer
        </motion.h2>

        {/* Offer Grid */}
        <motion.div
          variants={container}
          className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 mb-20"
        >
          {offers.map((offer, index) => (
            <motion.div
              key={index}
              variants={item}
              whileHover={{
                scale: 1.05,
                boxShadow: "0px 10px 25px rgba(0,0,0,0.15)",
              }}
              transition={{ type: "spring", stiffness: 200 }}
              className="bg-[#FFF0DC] rounded-2xl p-6 flex flex-col items-center text-center shadow-sm cursor-pointer"
            >
              <motion.div
                whileHover={{ rotate: 8 }}
                transition={{ type: "spring", stiffness: 150 }}
                className="mb-4"
              >
                {offer.icon}
              </motion.div>
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                {offer.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                {offer.desc}
              </p>
            </motion.div>
          ))}
        </motion.div>

        {/* Doctor Section */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-10">
          
          {/* Image */}
          <motion.div
            className="w-full md:w-1/2"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <img
              src={Welcome}
              alt="Doctor team"
              className="rounded-2xl w-full object-cover shadow-md"
            />
          </motion.div>

          {/* Text */}
          <motion.div
            className="w-full md:w-1/2 text-left"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 leading-snug">
              Welcome to Psychologist <br /> & Family Consulting
            </h2>
            <p className="text-gray-600 leading-relaxed max-w-md">
              It’s our goal to create a comfortable, safe environment where we work 
              together to achieve healing, emotional clarity, and personal growth.
            </p>
          </motion.div>

        </div>

      </div>
    </motion.section>
  );
};

export default OfferSection;
